import type { InlineVisualErrorProps } from '../types';

const InlineVisualError = ({ error }: InlineVisualErrorProps) => (
    <div className="bg-muted border border-border rounded-lg px-3.5 py-2.5 text-xs text-muted-foreground">
        Something went wrong displaying this result.
        {process.env.NODE_ENV === 'development' && error?.message && (
            <div className="mt-1 font-mono text-[11px] text-destructive">
                {error.message}
            </div>
        )}
    </div>
);

export default InlineVisualError;
